import { NotiflowsProvider } from '@notiflows/react';
import { useProfile } from '@/api';

export const AppCore = ({ children }: { children: React.ReactNode }) => {
  const { data: currentUser } = useProfile();

  return (
    <NotiflowsProvider
      apiUrl={import.meta.env.VITE_NOTIFLOWS_API_URL}
      wsUrl={import.meta.env.VITE_NOTIFLOWS_WEBSOCKET_URL}
      apiKey={import.meta.env.VITE_NOTIFLOWS_API_KEY}
      channelId={import.meta.env.VITE_NOTIFLOWS_CHANNEL_ID}
      userKey={currentUser.notiflowsUserKey}
      userId={currentUser.id}
    >
      {children}
    </NotiflowsProvider>
  );
};
